

import { useMutation, useQueryClient } from "@tanstack/react-query";
import type { SubscriptionPlanType, SubscriptionPlanView } from "@/lib/api/types";
import { endpoints } from "@/lib/api/endpoints";
import { apiJsonClient } from "@/lib/query/core/api-json-client";
import { invalidateAdminSubscriptions } from "@/lib/query/core/invalidation";
import { queryKeys } from "@/lib/query/core/query-keys";

type UpdateSubscriptionPlanInput = {
  subscriptionId: string;
  nameAr?: string;
  nameEn?: string;
  type?: SubscriptionPlanType;
  amount?: number;
  periodDays?: number;
  isActive?: boolean;
};

export function useUpdateSubscriptionPlanMutation() {
  const queryClient = useQueryClient();
  const mutation = useMutation({
    mutationFn: ({ subscriptionId, ...body }: UpdateSubscriptionPlanInput) =>
      apiJsonClient<SubscriptionPlanView>(endpoints.admin.subscriptionById(subscriptionId), {
        method: "PATCH",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(body),
      }),
    onSuccess: async (_data, variables) => {
      await invalidateAdminSubscriptions(queryClient);
      await queryClient.invalidateQueries({
        queryKey: queryKeys.admin.subscriptionById(variables.subscriptionId),
        exact: true,
      });
    },
  });

  return {
    mutateAsync: mutation.mutateAsync,
    isPending: mutation.isPending,
    error: mutation.error,
    reset: mutation.reset,
  };
}
